import {
  ShareIcon,
  MagnifyingGlassIcon,
  ArrowTrendingUpIcon,
  BellAlertIcon,
  ChartPieIcon,
  LightBulbIcon,
} from '@heroicons/react/24/solid'


const costVisiblityHref = '/features/cost-visibility'
const automatedSavingsHref = '/features/automated-savings'
const insightsHref = '/features/insights'
const integrationsHref = '/features/integrations'
const notificationsHref = '/features/monitors'
const usageGroupsHref = '/features/usage-groups'

export const featurePages = [
  {
    title: 'Visibility',
    description: 'Easily explore and monitor Snowflake usage',
    icon: MagnifyingGlassIcon,
    href: costVisiblityHref,
  },
  {
    title: 'Savings',
    description: 'Instantly save an average of 10-20% of your compute spend',
    icon: ArrowTrendingUpIcon,
    href: automatedSavingsHref,
  },
  {
    title: 'Integrations',
    description: 'Understand consumption from connected data tools',
    icon: ShareIcon,
    href: integrationsHref,
  },
  {
    title: 'Insights',
    description:
      'Save hours of work with intelligent optimization recommendations',
    icon: LightBulbIcon,
    href: insightsHref,
  },
  {
    title: 'Monitors',
    description:
      'Get notifications directly to Slack and Teams for peace of mind',
    icon: BellAlertIcon,
    href: notificationsHref,
  },
  {
    title: 'Usage Groups',
    description:
      'Allocate usage and set budgets for teams or projects by user, role and more',
    icon: ChartPieIcon,
    href: usageGroupsHref,
  },
]
